// MobileARCTIC — phone view for the ARCTIC presentations schedule.
//
// Simple stacked list — each card is two lines: Time / Topic on the left,
// School (team chip) / Author on the right. ARCTIC has no event-coupled delay
// so the topbar only carries the wall clock.

import type { ARCTICEntry, NavigateFn } from '../../types';
import { ProtoClockChip, ProtoTeamChip } from '../../components';
import { MobileTopbar } from '../../components/MobileTopbar';

export function MobileARCTIC({ entries, onMenu, onNavigate }: {
  entries: ARCTICEntry[];
  onMenu: () => void;
  onNavigate?: NavigateFn;
}) {
  return (
    <div className="mw-app">
      <MobileTopbar
        title="ARCTIC"
        subtitle={`ROOM 3 · ${entries.length} SCHEDULED`}
        onMenu={onMenu}
        right={<ProtoClockChip hideTime />}
      />
      <div className="mw-body">
        <div className="mw-list-head">
          <span>PRESENTATIONS</span>
          <span>{entries.length} TOTAL</span>
        </div>
        {entries.map((a) => (
          <div key={a.id} className="mw-mrow">
            {/* Two-line card: Time / Topic on the left, School / Author on the right. */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 3, minWidth: 0 }}>
                <span className="mono tnum" style={{ fontSize: 11, color: 'var(--text-1)' }}>{a.day} · {a.time}</span>
                <div style={{
                  fontFamily: 'var(--font-display)', fontSize: 16, letterSpacing: '0.03em',
                  color: 'var(--text-0)', lineHeight: 1.2,
                }}>{a.topic}</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 4, alignItems: 'flex-end', flexShrink: 0 }}>
                <ProtoTeamChip
                  id={a.team}
                  logo
                  onClick={onNavigate ? () => onNavigate('teams', { team: a.team }) : undefined}
                />
                <div className="mono" style={{
                  fontSize: 10, color: 'var(--text-2)', letterSpacing: '0.06em', textAlign: 'right',
                }}>{a.presenter.toUpperCase()}</div>
              </div>
            </div>
          </div>
        ))}
        <div className="mw-tail-spacer" />
      </div>
    </div>
  );
}
